<template>
  <div>
    <div v-if="!questionAnswered" class="px-4">
      <div class="mt-6 py-5 text-left">
        <session-logo :session="session"></session-logo>

        <h1 class="text-lg font-extralight">
          {{ generatedQuestion }}
        </h1>
        <p v-if="question.sub_question" class="mt-3 text-sm font-extralight">
          {{ question.sub_question }}
        </p>

        <div class="border-t border-gray-400 mt-4"></div>
      </div>

      <form @submit.prevent="submit" novalidate class="mt-3 text-center">
        <div class="bg-white shadow overflow-hidden">
          <ul>
            <li v-for="(choice, idx) in choices" :key="idx" @click="select(choice)" class="
                cursor-pointer
                block
                focus:outline-none
                transition
                duration-150
                ease-in-out
              " :class="customClass(choice, idx)">

              <div class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 mr-5"
                    :class="choice.selected ? 'text-white' : 'text-gray-200'">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>

                  <div class="text-sm leading-5 font-medium truncate"
                    :class="choice.selected ? 'text-white' : 'text-gray-600'">
                    {{ choice.value }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <submit-button :sending="sending" :validated="validated" class="max-w-4xl ml-auto mr-auto mt-4">{{
          translations.save }}</submit-button>
      </form>
    </div>

    <div v-if="questionAnswered" class="mt-6 px-8 py-5 text-left">
      <h1 class="text-3xl font-extralight mb-3">
        {{ translations.thank_you }}
      </h1>

      <a :href="route('diy-workshops.phase', {
        uuid: participant.uuid,
      })
        "
        class="block mx-auto mt-12 w-min rounded-md border border-transparent px-2 py-3 bg-brandpreneurship-dark-gray  font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 text-sm leading-5 z-50">WEITER</a>
    </div>
  </div>
</template>

<script>
import SubmitButton from '@/Shared/SubmitButton';
import { throttle } from 'lodash';
import SessionLogo from '@/Pages/DiyWorkshop/Shared/SessionLogo';

export default {
  components: {
    SubmitButton,
    SessionLogo,
  },

  props: {
    translations: {},
    participant: {
      required: true,
    },
    question: {
      required: true,
    },
    session: {
      required: true,
      type: Object,
    },
    answerParameters: {},
  },

  data() {
    return {
      sending: false,
      answered: false,
      choices: {},
      form: {
        choice: {},
      },
    };
  },

  created() {
    // this.channel.here((users) => {
    //     // console.log(users);
    // })

    let parameters = this.question.parameters;
    // console.log(parameters);

    this.choices = parameters.choices.map((choice) => {
      return {
        value: choice,
        selected: false,
      };
    });


  },


  methods: {
    select(selectedChoice) {
      this.form.choice = selectedChoice;

      this.choices = this.choices.map((choice) => {
        return {
          value: choice.value,
          selected: selectedChoice.value == choice.value ? true : false,
        };
      });

      // this.$set(choice, 'selected', !choice.selected);
    },
    submit() {
      this.sending = true;

      window.axios
        .post(
          this.route('diy-workshops.questions.store', {
            uuid: this.participant.uuid,
            questionId: this.question.id,
          }),
          this.form
        )
        .then(() => {
          this.sending = false;

          // this is an easy way to change the workflow:
          // now after clicking on "save" the user automatically 
          // lands on the next question
          window.location.reload();
          // this.answered = true;
        })
        .catch((error) => {
          this.sending = false;
        });
    },

    customClass(choice, idx) {
      let classes = '';

      if (idx) {
        classes += 'border-t border-gray-200 ';
      }

      if (choice.selected) {
        classes +=
          'bg-markencode-blue hover:bg-markencode-blue focus:bg-markencode-blue';
      } else {
        classes += 'bg-white hover:bg-gray-50 focus:bg-gray-50';
      }

      return classes;
    },

  },

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },

    // selected() {
    //   if (this.choices.length) {
    //     return this.choices.filter((choice) => choice.selected).length;
    //   }

    //   return 0;
    // },

    validated() {
      return Object.keys(this.form.choice).length > 0;
    },

    questionAnswered() {
      // return (
      //   (this.answerParameters && this.answerParameters.choices.length > 0) ||
      //   this.answered
      // );

      if (this.answered) {
        return true;
      }

      if (!this.answerParameters) {
        return false;
      }

      return Object.keys(this.answerParameters).length > 0;

      // return false;
    },

    // channel() {
    //   return Echo.channel(
    //     'markencode-productivity.session.' + this.participant.markencode_session.id
    //   );
    // },
  },


};
</script>